import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const productoImporterSelectors = importerSelectors(
  'producto.importer',
);

export default productoImporterSelectors;
